/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Credits_LabelInputs */

const en_sidebar_credits_label = /** @type {(inputs: Sidebar_Credits_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Credits`)
};

const de_sidebar_credits_label = /** @type {(inputs: Sidebar_Credits_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Guthaben`)
};

const fr_sidebar_credits_label = /** @type {(inputs: Sidebar_Credits_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits IA`)
};

const es_sidebar_credits_label = /** @type {(inputs: Sidebar_Credits_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creditos IA`)
};

const it_sidebar_credits_label = /** @type {(inputs: Sidebar_Credits_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crediti IA`)
};

const nl_sidebar_credits_label = /** @type {(inputs: Sidebar_Credits_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-credits`)
};

const pl_sidebar_credits_label = /** @type {(inputs: Sidebar_Credits_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredyty AI`)
};

const fi_sidebar_credits_label = /** @type {(inputs: Sidebar_Credits_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-krediitit`)
};

const da_sidebar_credits_label = /** @type {(inputs: Sidebar_Credits_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-credits`)
};

const sv_sidebar_credits_label = /** @type {(inputs: Sidebar_Credits_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-krediter`)
};

/**
* | output |
* | --- |
* | "AI Credits" |
*
* @param {Sidebar_Credits_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const sidebar_credits_label = /** @type {((inputs?: Sidebar_Credits_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Credits_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sidebar_credits_label(inputs)
	if (locale === "fr") return fr_sidebar_credits_label(inputs)
	if (locale === "es") return es_sidebar_credits_label(inputs)
	if (locale === "it") return it_sidebar_credits_label(inputs)
	if (locale === "nl") return nl_sidebar_credits_label(inputs)
	if (locale === "pl") return pl_sidebar_credits_label(inputs)
	if (locale === "fi") return fi_sidebar_credits_label(inputs)
	if (locale === "da") return da_sidebar_credits_label(inputs)
	if (locale === "sv") return sv_sidebar_credits_label(inputs)
	return en_sidebar_credits_label(inputs)
});